import React, { useState, useEffect } from 'react';
import axios from "axios";
import { useSelector } from 'react-redux';
import { baseUrl } from "../../shared/baseUrl";
import { NavLink, useNavigate} from 'react-router-dom';
import Header from '../../components/admin/Header';
import SideBar from '../../components/admin/SideBar';
import Modal  from 'react-modal';
import { VscChromeClose } from 'react-icons/vsc';
import ReactPaginate from "react-paginate";
import TableHandler from '../../components/admin/TableHandler';
import moment from 'moment';

const ViewRequest = () => {
  const navigate = useNavigate()

  Modal.setAppElement('#root');
  
  const [modalOpen, setModalOpen] = useState(false)

  const [data, setData] = useState([])

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  // --- Pagination --- //
  const [pageNumber, setPageNumber] = useState(0)
  const itemsPerPage = 10
  const pagesVisited = pageNumber * itemsPerPage
  const pageCount = Math.ceil(data?.length / itemsPerPage)
  const changePage = ({ selected }) => setPageNumber(selected)
  const displayData = data?.slice(pagesVisited, pagesVisited + itemsPerPage)
  // --- Pagination --- //

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin
    
  useEffect(() => {
    document.title = "Island Luxury - Property Requests"
    if(!userInfo) {
      navigate('/')
    } 
    else {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userInfo?.token}`
        }
      }
      const getAgents = async () => {
        try {
          setLoading(true)
          const res = await axios.get(baseUrl + "/api/v1/requests", config)
          setLoading(false)
          setData(res.data.requests)
        }
        catch(err){
          setLoading(false)
          setError(err.response && err.response.data.message ? err.response.data.message : err.message)
        }
      }
      getAgents()
    }
  }, [userInfo, navigate])

  const [toggleNav, setToggleNav] = useState(false)

  return (
    <div id="admin-page_wrap">
      <Header toggleNav={toggleNav} setToggleNav={setToggleNav} />
      <SideBar toggleNav={toggleNav} />
      <main id="my-listing">
        <section className="page-title">
          <h3><NavLink to="/dashboard">Dashboard</NavLink> | Property Requests</h3>
        </section>
        <section className="my-listing_cont">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Mobile No:</th>
                <th>Date</th>
                <th>Type</th>
                <th>Location</th>
                <th>Category</th>
                <th>Bed(s)</th>
                <th>Budget</th>
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {!loading && displayData.map((item, i) => 
                <tr key={i}>
                  <td>{item.fullname}</td>
                  <td>{item.email}</td>
                  <td>{item.phoneNumber}</td>
                  <td>{moment(item.createdAt).format('ll')}</td>
                  <td>{item.propertyType}</td>
                  <td>{item.state}</td>
                  <td>{item.category}</td>
                  <td>{item.beds}</td>
                  <td>{item.budget}</td>
                  {/* <td>
                    <button className="table-link" onClick={() => setModalOpen(true)}>
                      View
                    </button>
                  </td> */}
                </tr>
              )}
            </tbody>
          </table>

          <TableHandler data={data} loading={loading} error={error} />

          {data?.length > itemsPerPage &&
            <div className="pagination-tab">
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                pageCount={pageCount}
                onPageChange={changePage}
                containerClassName={"paginationBttns"}
                previousLinkClassName={"previousBttn"}
                nextLinkClassName={"nextBttn"}
                disabledClassName={"paginationDisabled"}
                activeClassName={"paginationActive"} />
            </div>
					}

        </section>

        <Modal isOpen={modalOpen} closeTimeoutMS={200}> 
          <div className="modal-header">
            <h2>Modal Title</h2>
            <button onClick={() => setModalOpen(false)}>
              <VscChromeClose size={25} />
            </button>
          </div>
        </Modal>

      </main>
    </div>
  )
}

export default ViewRequest;
